import type { Immutable } from "immer";
import React from "react";

import type { HardcodedBlock as HardcodedBlockValue } from "@reactivated";

import { JdPower2026Banner } from "../../../components/JdPower2026Banner";

type IProps = Immutable<{ value: HardcodedBlockValue }>;

/**
 * The page link wins over the external URL. With neither set, the banner shows
 * no "Learn More" link.
 */
const getLearnMoreHref = (value: IProps["value"]): string | null =>
    value.learn_more_page?.url || value.learn_more_url || null;

/** ``hc-block--jdpower-2026--banner-overlay`` (#37284). */
export const JdPower2026BannerOverlay = (props: IProps): React.JSX.Element => (
    <JdPower2026Banner
        variant="overlay"
        learnMoreHref={getLearnMoreHref(props.value)}
    />
);

/** ``hc-block--jdpower-2026--banner-blue-mobile`` (#37286). */
export const JdPower2026BannerBlueMobile = (
    props: IProps,
): React.JSX.Element => (
    <JdPower2026Banner
        variant="blue"
        learnMoreHref={getLearnMoreHref(props.value)}
    />
);
